import React from "react";
import "./app.css";
import Routing from "./routes";

function App() {
  return (
    <React.Fragment>
      <Routing />
    </React.Fragment>
  );
}

export default App;
